import { DateTime } from 'luxon';

export class DownloadPsReceiptModalResult {
  /** @constructor */
  constructor(
    /** Data selezionata */
    public selectedDate: DateTime,
  ) {}
}
